import { PreparationModel } from './preparation.model';
import { Deserializable } from 'projects/core/src/lib/models/deserializable';
import { BaseModel } from 'projects/core/src/lib/models/base.model';
import { MarkModel } from './mark.model';
import { RunnerOnlinetestModel } from './runner-onlinetest.model';
import { AcStatusTimingsType, AcStatusUserType, BusyType } from './acstatus/ac-status.type';

export class CandidateModel extends BaseModel implements Deserializable {

  // columns
  hashed_id: string;
  firstname: string;
  lastname: string;
  email: string;
  timezone: string;
  role: string;
  tz_offset: string; // tslint:disable-line: variable-name
  directlink: string;
  recommendation?: number | null;
  rating_comments: { [key: number]: string } | null = null

  // relations
  preparations: Array<PreparationModel> = [];
  onlinetests: Array<RunnerOnlinetestModel> = [];
  marks: Array<MarkModel> = [];

  // client
  userStatus: AcStatusUserType = null;
  timing: AcStatusTimingsType = null;
  busy: BusyType | null = null;
  avatar: string | null;

  deserialize(input: any): this {
    Object.assign(this, input);
    // preparations
    let preparations = null;
    if (this.preparations !== null && this.preparations !== undefined) {
      preparations = [];
      this.preparations.forEach((preparation: PreparationModel) => {
        preparations.push(new PreparationModel().deserialize(preparation));
      });
    }
    this.preparations = preparations;
    // marks
    let marks = null;
    if (this.marks !== null && this.marks !== undefined) {
      marks = [];
      this.marks.forEach((mark: MarkModel) => {
        marks.push(new MarkModel().deserialize(mark));
      });
    }
    this.marks = marks;
    // onlinetests
    let onlinetests = null;
    if (this.onlinetests !== null && this.onlinetests !== undefined) {
      onlinetests = [];
      this.onlinetests.forEach((onlinetest: RunnerOnlinetestModel) => {
        onlinetests.push(new RunnerOnlinetestModel().deserialize(onlinetest));
      });
    }
    this.onlinetests = onlinetests;
    return this;
  }

  get fullname(): string {
    return (this.firstname && this.lastname) ? this.firstname + ' ' + this.lastname : '-';
  }

  get initials(): string {
    return (this.firstname && this.lastname) ? this.firstname[0] + this.lastname[0] : '-';
  }

  public setUserStatus(userStatus: AcStatusUserType): void {
    this.userStatus = userStatus;
    if (this.userStatus.timezone) {
      this.timezone = this.userStatus.timezone;
    }
    if (this.userStatus.timezone) {
      this.tz_offset = this.userStatus.tz_offset;
    }
    if (this.userStatus.avatar === 'DELETED') {
      this.avatar = null;
    } else if (this.userStatus.avatar) {
      this.avatar = this.userStatus.avatar;
    }
  }

  public isOnline(): boolean {
    return this.userStatus?.is_online === true;
  }

  public isBusy(): boolean {
    return this.busy !== null;
  }

  public setRatingComment(slot: number, comment: string): void {
    this.rating_comments = this.rating_comments || {};
    this.rating_comments[slot] = comment;
  }

  public getRatingComment(slot: number): string {
    return this.rating_comments?.[slot] || '';
  }

}
